<template>
  <div class="container">
    <div class="box" v-for="item in itoContents" :key="item.id">
      <div class="title">{{ item.title }}</div>
      <div class="content" v-for="items in item.content" :key="items.index">
        {{ items }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Ito",
  components: {},
  data() {
    ``;
    return {
      itoContents: [
        {
          id: 1001,
          title: "多种服务合作模式",
          content: [
            "项目开发",
            "现场开发(Onsite)",
            "离岸开发(ODC)",
            "战略合作 共同开拓市场",
            "解决方案",
          ],
        },
        {
          id: 1002,
          title: "完善的服务交付体系",
          content: [
            "通过科学规范的质量管理体系，领先的交付管理体系和完善的人资管理体系，邦睿科技拥有行业领先的实施交付能力。",
          ],
        },
        {
          id: 1003,
          title: "项目管理",
          content: [
            "离岸开发中心服务",
            "资源型软件定制开发服务",
            "项目型软件定制开发服务",
          ],
        },
        {
          id: 1004,
          title: "资源管理",
          content: [
            "研发人员占比 91%+",
            "全天候本地化人才供给",
            "中高级复合型人才培养",
            "精准人才选用育留机制",
            "产学研创协同育人平台",
          ],
        },
        {
          id: 1005,
          title: "质量管理",
          content: [
            "全生命周期项目交付流程",
            "规范的标准动作",
            "专业的项目管理队伍",
            "全面的项目交付能力",
            "完善的项目内控管理",
            "统一的交付管理平台",
          ],
        },
        {
          id: 1006,
          title: "信息安全",
          content: [
            "政策法规",
            "组织结构",
            "物理空间（独立）",
            "业务流程",
            "人员管理",
            "技术实施",
            "标准规范",
          ],
        },
        {
          id: 1007,
          title: "主要服务类型",
          content: [
            "信息系统与应用开发——产品开发与基础设施工程——软件与电子产品测试——IT运维",
          ],
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  box-sizing: border-box;
  padding: 40px;
  margin: 90px auto 20px auto;
  width: 980px;
  background-color: #fff;
  .box {
    margin-bottom: 30px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #0c6fb5;
      line-height: 18px;
      padding-left: 20px;
      background: url("~@/assets/arrow.png") no-repeat center left;
      margin-bottom: 20px;
    }
    .content {
      margin-left: 20px;
      font-size: 14px;
      line-height: 22px;
      margin-top: 11px;
      color: #5b5b5b;
    }
  }
}
</style>
